var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05 13.275L3 12.225L10.275 4.94998L14.025 8.69998L19.5 3.22498L20.55 4.27498L14.025 10.8L10.275 7.04998L4.05 13.275Z",
    fill: "#3E7BFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.775 6.75H19.275V4.5H17.025V3H20.775V6.75Z",
    fill: "#3E7BFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.775 19.5H3.52502V21H20.775V19.5Z",
    fill: "#3E7BFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27502 20.25H5.77502V15.75H5.02502V20.25H3.52502V14.25H7.27502V20.25Z",
    fill: "#3E7BFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.775 20.25H10.275V12H9.52502V20.25H8.02502V10.5H11.775V20.25Z",
    fill: "#3E7BFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.775 20.25H19.275V12H18.525V20.25H17.025V10.5H20.775V20.25Z",
    fill: "#3E7BFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.275 20.25H14.775V14.25H14.025V20.25H12.525V12.75H16.275V20.25Z",
    fill: "#3E7BFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightActive);
export default __webpack_public_path__ + "static/media/insightActive.6f4d0aba4e7e03ad4d131907f727dd39.svg";
export { ForwardRef as ReactComponent };